import { useField } from "formik";
import React from "react";
import { Form,    Label, TextArea } from "semantic-ui-react";

interface Props {
    children?: never[];
    name: string;
    placeholder: string;
    label?: string;
    type?: string;
    maxLength?: number;
    focus?: boolean;
}
export default function MyMultiTextInputNonFluid(props: Props){
    const [field, meta] = useField(props.name);

    return (
        <Form.Field inline error={meta.touched && !!meta.error}>
            <label>{props.label}</label>
            <TextArea  fluid {...field} {...props}  maxLength={props.maxLength} rows="20"/>
            {meta.touched && meta.error ? <Label basic color='red'>{meta.error}</Label> : null
            } 
        </Form.Field>
    );
}